module.exports = __webpack_public_path__ + "img/bar_active_bg3.110cf655.png";